import type { ZudokuConfig } from "zudoku";
import { zuploMonetizationPlugin } from "@zuplo/zudoku-plugin-monetization";

const config: ZudokuConfig = {
  site: {
    title: "Rate My OpenAPI",
    logo: {
      src: {
        light: "https://cdn.zuplo.com/static/logos/rate-my-openapi-v2.png",
        dark: "https://cdn.zuplo.com/static/logos/rate-my-openapi-v2.png",
      },
      alt: "Rate My OpenAPI",
      href: "/"
    },
  },
  defaults: {
    apis: {
      showInfoPage: false
    }
  },
  metadata: {
    title: "Rate My OpenAPI",
    description: "The API documentation for Rate My OpenAPI from Zuplo.",
  },
  navigation: [
    {
      type: "category",
      label: "Documentation",
      items: [
        {
          type: "doc",
          file: "introduction",
          path: "/",
        },
        "cli",
        "github-action",
      ],
    },
    {
      type: "link",
      to: "/api",
      label: "API Reference",
      icon: "code",
    },
  ],
  docs: {
    files: "pages/**/*.{md,mdx}",
    publishMarkdown: true,
    llms: {
      llmsTxt: true,
      llmsTxtFull: true,
      includeProtected: false
    },
  },
  apis: {
    type: "file",
    input: "../config/routes.oas.json",
    path: "/api",
  },
  authentication: {
    type: "auth0",
    domain: "auth.ratemyopenapi.com",
    clientId: "uubVfxh6HzSJanZvMIzmjFPDBkn81Rtp",
    audience: "https://api.ratemyopenapi.com/",
  },
  apiKeys: {
    enabled: true,
  },
  plugins: [
    zuploMonetizationPlugin()
  ],
  theme: {
    light: {
      primary: "rgb(42, 47, 69)",
      background: "white",
    },
    dark: {
      primary: "#f7fafc",
      background: "#1a1f36",
    },
    customCss: `
      a[href="/manage-payment"] {
        display: none !important;
      }
    `,
  },
};

export default config;
